<template>
  <nav class="col-md-3 col-lg-2 sidebar">
    <div class="position-sticky">
      <ul class="nav flex-column mt-4">
        <li class="nav-item my-1">
          <router-link class="nav-link" active-class="text-info" to="anasayfa">
            <i class="fas fa-home"></i>
            Anasayfa
          </router-link>
        </li>
        <li class="nav-item my-1">
          <router-link class="nav-link" active-class="text-info" to="mesajlar">
            <i class="fas fa-envelope"></i>
            Mesajlar
          </router-link>
        </li>
        <li class="nav-item my-1">
          <router-link class="nav-link" active-class="text-info" to="profil">
            <i class="fas fa-user"></i>
            Profil
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style></style>
